import {Ability} from '~/lib/ability';

export class FeaturesAbility extends Ability {
    canEdit = () => this.isAdmin();
}
